import { createContext } from "react";

import type usePatientItemIdentityById from "src/hooks/data/load/usePatientItemIdentityById";

/**
 * Describes the patient item identity loader state and its refresh/cache actions.
 */
export interface IPatientItemIdentityContext extends ReturnType<
    typeof usePatientItemIdentityById
> {}

/**
 * Shares patient item identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<IPatientItemIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
